export enum ConnectionModeEnum {
  aucun = 'aucun',
  microsoft = 'microsoft',
  google = 'google'
}
